import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
    AnimatedPanel,
    SectionTitle,
    SectionDescription,
    CardsContainer,
    Card,
    CardImage,
    CardLabel,
    Small,
} from "./ui/StyledUI";
import { ReactComponent as SidebarButtonIcon } from "../../../../assets/images/icons/Sidebar.svg";
import Modal from "../../components/Modal";
import InteractionsUploadModal from "./components/InteractionsUploadModal";

const interactionOptions = [
    { value: "none", label: "None" },
    { value: "arcade", label: "Arcade" },
    { value: "guestbook", label: "Guestbook" },
    { value: "linkout", label: "Linkout" },
    { value: "music", label: "Music" },
];

export default function Interactions({
    selected,
    setSelectedSection,
    onSelectOption = () => {},
    interactionItems = [],
    roomType,
    roomId,
}) {
    const titleRoomType = roomType.charAt(0).toUpperCase() + roomType.slice(1);
    const count = interactionItems.length;
    const frameRefs = useRef({});
    const [highlighted, setHighlighted] = useState(null);
    const [selectedRadio, setSelectedRadio] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onSubmitUploadedMedia = (uploadedMediaUrl) => {
        // Handle the uploaded media URL here
        console.log("Uploaded media URL:", uploadedMediaUrl);
    };

    useEffect(() => {
        if (selected && frameRefs.current[selected]) {
            const el = frameRefs.current[selected];
            el.scrollIntoView({ behavior: "smooth", block: "center" });
            setHighlighted(selected);
        }
    }, [selected]);

    const handleClickBack = () => {
        onSelectOption(null);
        setSelectedSection("Overview");
        setHighlighted(null);
    };

    const handleSelectRadio = (e, itemName) => {
        const value = e.target.value;
        setSelectedRadio(value);

        // Open modal immediately on selecting any option except "none"
        if (value !== "none") {
            setIsModalOpen(true);
        }
    };

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <StyledSidebarButtonIcon onClick={handleClickBack} />
                    <div>
                        <SectionTitle>Interactions</SectionTitle>
                    </div>
                </div>
                {interactionItems.map((f) => (
                    <AnimatedPanel
                        key={f.name}
                        ref={(el) => {
                            frameRefs.current[f.name] = el;
                        }}
                        style={{
                            boxShadow: highlighted === f.name ? "0 0 12px rgba(180, 140, 255, 0.6)" : "none",
                            transition: "box-shadow 0.4s ease",
                        }}
                    >
                        <PanelContent>
                            <LeftSide>
                                <p style={{ fontWeight: 700, fontSize: "18px" }}>{f.name}</p>
                                <p style={{ fontWeight: 400, fontSize: "14px", marginTop: "5px" }}>
                                    {" "}
                                    Add an interaction to this item.
                                </p>
                                <RadioGroup>
                                    {interactionOptions.map((opt) => {
                                        const id = `interaction-${f.name}-${opt.value}`;

                                        return (
                                            <RadioRow key={opt.value}>
                                                <input
                                                    id={id}
                                                    type="radio"
                                                    name={`interaction-${f.name}`}
                                                    value={opt.value}
                                                    checked={selectedRadio === opt.value}
                                                    onChange={(e) => handleSelectRadio(e, f.name)}
                                                />

                                                <label htmlFor={id}>{opt.label}</label>
                                            </RadioRow>
                                        );
                                    })}
                                </RadioGroup>
                            </LeftSide>
                            <ThinVL />
                            <RightSide>
                                <CardImage
                                    src={f.img}
                                    alt={f.name}
                                    style={{
                                        height: f.name.includes("vertical") ? "250px" : "150px",
                                        objectFit: "cover",
                                    }}
                                />
                            </RightSide>
                        </PanelContent>
                    </AnimatedPanel>
                ))}
            </div>
            <Modal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                children={
                    <InteractionsUploadModal
                        selected={selected}
                        setIsModalOpen={setIsModalOpen}
                        onSubmitUploadedMedia={onSubmitUploadedMedia}
                        roomId={roomId}
                    />
                }
            />
        </>
    );
}

const btnStyle = {
    padding: "10px 14px",
    background: "linear-gradient(180deg, rgba(157,117,245,0.12), rgba(157,117,245,0.06))",
    border: "1px solid rgba(157,117,245,0.14)",
    color: "#e9dbff",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: 700,
};

const PanelContent = styled.div`
    display: flex;
    width: 100%;
`;

const LeftSide = styled.div`
    width: 60%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

const RightSide = styled.div`
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CardMedia = styled.div`
    margin-top: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
`;

const BoxDescription = styled.div`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
`;

const ThinVL = styled.div`
    width: 1px;
    background: rgba(255, 255, 255, 0.06);
    margin: 0 10px;
`;

const StyledSidebarButtonIcon = styled(SidebarButtonIcon)`
    width: 35px;
    height: 35px;
    padding: 7px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    margin-left: 5px;
    transition: transform 0.3s;
`;
const RadioGroup = styled.div`
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 12px;
`;

const RadioRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    input {
        width: 18px;
        height: 18px;
        accent-color: #a97bff; /* purple like screenshot */
    }

    label {
        font-size: 16px;
        color: #e9dbff;
    }
`;
